import Panzoom from '@panzoom/panzoom';

export const getDimensions = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

export const getValidSteps = (level, steps, origWidth) => {
  const dims = getDimensions();
  let validSteps = steps;
  if (origWidth) {
    // Test how much zoom can actually be done without losing quality
    while (Math.pow(level, validSteps) * dims.width > origWidth && validSteps > 0) {
      validSteps--;
    }
  } else {
    console.error('Could not retrieve original image dimensions');
  }

  return validSteps;
};

export const initPanzoom = (zoomWrap, level, steps) => {
  return Panzoom(zoomWrap, {
    maxScale: Math.pow(level, steps),
    minScale: 1,
    step: level,
    contain: 'outside',
    panOnlyWhenZoomed: true
  });
};

export const getOriginalAssetInfo = props => {
  return new Promise((resolve, reject) => {
    const url = props.context.cloudinary.getInfoUrl(props.asset && props.asset.publicId);
    fetch(url).then(
      res => resolve(res.json()),
      () => reject()
    );
  });
};
